import { Component, Injector, OnInit } from '@angular/core';
import { GroupService } from 'tnx-admin-service/group/services';
import { ComponentContextService, DataFormBase, EventData, FormSchemaBase, TextAreaControlSchema, TextControlSchema } from 'tnx-shared';

@Component({
    selector: 'group-form',
    templateUrl: './group-form.component.html',
    styleUrls: ['./group-form.component.scss'],
    providers: [ComponentContextService]
})
export class GroupFormComponent extends DataFormBase implements OnInit {

    constructor(
        protected _injector: Injector,
        protected _hodidayService: GroupService,
    ) {
        super(_injector);
    }

    ngOnInit() {
        super.ngOnInit();
        this.setting.baseService = this._hodidayService;
        this.setting.schema = <FormSchemaBase[]>[
            new TextControlSchema({
                field: 'code',
                label: this._translateService.instant('Mã'),
                required: true,
                mdWidth: 12
            }),
            new TextControlSchema({
                field: 'name',
                label: this._translateService.instant('Tên'),
                mdWidth: 12
            }),
            new TextControlSchema({
                field: 'sort',
                label: this._translateService.instant('Thứ tự'),
                mdWidth: 12,
                dataFormat: 'number'
            }),
            new TextAreaControlSchema({
                field: 'description',
                label: this._translateService.instant('Ghi chú'),
                mdWidth: 12
            })
        ];
    }


    async onFormInitialized(constrols: EventData) {
        // tiền xử lý dữ liệu (ví dụ tổng hợp datasource), trước khi gọi api get detail
    }

    async modifyDetailData(data) {
        // xử lý dữ liệu lấy từ get detail về
    }

    async onAfterGetDetail() {
        // xử lý dữ liệu sau khi đã lấy từ api (sau cả event modifyDetailData) về và trước khi hiển thị ra view
    }

    onBeforeSave() {
        // trước khi lưu
    }

}
